import React from 'react';
import { Info } from 'lucide-react';
import QuestionButtonHelp from 'src/shared/components/question-button-help/QuestionButtonHelp';

type RankCardProps = {
    title: string;
    rank: string | null;
    total: number | null;
    isLoading: boolean;
    slug: string;
    className?: string;
    variant?: 'stacked' | 'inline';
    subtitle?: string;
};

const RankCard = ({ title, rank, total, isLoading, slug, className, variant = 'stacked', subtitle }: RankCardProps) => {
    if (isLoading) {
        return (
            <div
                className={`bg-white shadow-portfolio-summary-card rounded-lg p-4 flex flex-col gap-3 animate-pulse${
                    className ? ` ${className}` : ''
                }`}
            >
                <div className='h-4 bg-grey-20 rounded w-1/2' data-testid='rank-card-skeleton' />
                <div className='h-8 bg-grey-20 rounded w-1/3' />
                <div className='h-3 bg-grey-20 rounded w-1/4' />
            </div>
        );
    }

    return (
        <div className={`bg-white shadow-portfolio-summary-card rounded-lg p-4 flex flex-col gap-3${className ? ` ${className}` : ''}`}>
            <div className='flex items-center gap-2'>
                <span className='text-base text-primary'>{title}</span>
                <QuestionButtonHelp type='api' placement='top' slug={slug} icon={<Info className='h-4 w-4 text-primary' />} />
            </div>
            {variant === 'inline' ? (
                <div className='flex flex-col gap-3'>
                    <div className='flex items-end gap-2'>
                        <span className='text-3xl  text-black leading-8'>{rank ?? '—'}</span>
                        <span className='text-xl  text-muted-foreground leading-6'>/{total !== null ? total : '—'} sites</span>
                    </div>
                    {subtitle && (
                        <span className='text-xs font-normal text-muted-foreground' data-testid='rank-card-subtitle'>
                            {subtitle}
                        </span>
                    )}
                </div>
            ) : (
                <div className='flex flex-col gap-1'>
                    <span className='text-3xl  text-black leading-none'>{rank ?? '—'}</span>
                    <span className='text-xs  text-muted-foreground'>out of {total !== null ? total : '—'} sites</span>
                    {subtitle && (
                        <span className='text-xs  text-muted-foreground' data-testid='rank-card-subtitle'>
                            {subtitle}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};

export default RankCard;
